<div class="container-fluid mt-3 mb-3">
  <div class="row logos-menu m-0">
    <div class="d-none d-lg-block col-xl-2 col-sm-3">
      <img
        src="../../../../assets/images/LOGO_AMBIENTE_2023_02.png"
        alt="Logo Vital"
        title="Ministerio de Ambiente y Desarrollo Sostenible"
        class=""
        height="48px"
      />
    </div>
    <div class="col-xl-8 col-lg-9">
      <h1 class="page-title">
        <span style="letter-spacing: 0px"
          >Centro de Información y Monitoreo Ambiental - CIMA
        </span>
      </h1>
    </div>
  </div>
</div>


<div class="container-navbar-menu-govco lime-green-menu-govco">
  <nav
    class="navbar navbar-expand-lg navbar-menu-govco"
    role="navigation"
    aria-label="Menú ejemplo entidad"
  >
    <div class="container-fluid container-second-navbar-menu-govco">
      <a
        class="navbar-brand-mobile navbar-toggler"
        title="Ministerio de Ambiente y Desarrollo Sostenible"
        aria-label="Ir al Portal MinAmbiente"
        alt="Logo Vital"
      >
        <img
          class="w-100 logo-min-ambiente-mobile"
          src="../../../../assets/images/LOGO_AMBIENTE_2023_02.png"
          alt="Logo Vital"
          title="Ministerio de Ambiente y Desarrollo Sostenible"
        />
      </a>
      <button
        class="navbar-toggler button-responsive-menu-govco collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNavMinAmb"
        aria-controls="navbarNavMinAmb"
        aria-expanded="false"
        aria-label="Toggle navigation"
        #btnCollapsed
      >
        <span class="icon-bars-menu-govco"></span>
      </button>

      <div
        class="collapse navbar-collapse navbar-collapse-menu-govco"
        id="navbarNavMinAmb"
      >
        <ul class="navbar-nav navbar-nav-menu-govco ms-auto">
          <li
            class="nav-item"
            *ngFor="let item of menu"
            [ngClass]="returnClassList(item)"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <app-menu-item
              [rolesUsuario]="rolesUsuario"
              [item]="item"
              (cerrarMenu)="cerrarMenu()"
            ></app-menu-item>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>

<wecmp-sso-login
  texto="Información clave para la toma oportuna de decisiones del sector ambiental y desarrollo sostenible."
  [attr.url-key-cloak]="urlKeycloak"
  [attr.realm-key-cloak]="realmKeycloak"
  [attr.client-id-key-cloak]="clientIdKeycloak"
  is-fluid="true"
  [required-login-start]="false"
  (tokenResolved)="onTokenResolved($event)"
></wecmp-sso-login>
